import {register} from "../../../JavaScript/Utils";

export interface SearchBar {
  el: HTMLElement;
}

const delay = async (ms: number) => {
  await new Promise(resolve => {
    return setTimeout(resolve, ms)
  });
};

export const SearchBar = async (el: HTMLElement) => {

  if (!(<any>window).dataLayer) {
    await delay(1000);
  }

  if ((<any>window).dataLayer && el.hasAttribute("data-query")) {
    (<any>window).dataLayer.push({
      'search_term' : el.dataset.query
    });
  }
};

register("SearchBar", SearchBar);
